import React, { FC } from 'react';
import { Dropdown, DropdownItemProps } from '.';

import './DataViewItem.scss';

export interface DataInfoViewItemProps {
  readonly rightElement?: React.JSX.Element | React.JSX.Element[] | string;
  readonly id: string;
  readonly title: React.JSX.Element | string;
  readonly subtitle?: string;
  readonly content?: React.JSX.Element | React.JSX.Element[];
  readonly dropdownItems?: DropdownItemProps[];
}

export const DataViewItem: FC<DataInfoViewItemProps> = ({
  content,
  dropdownItems,
  id,
  rightElement,
  title,
  subtitle,
}) => (
  <div className="data-item" id={id}>
    <div className="data-item-end">
      <span className="data-item-end-text text-secondary">{rightElement}</span>
      {dropdownItems && <Dropdown button items={dropdownItems} />}
    </div>
    <div>
      {title}
      {subtitle && <small>&nbsp;({subtitle})</small>}
    </div>
    {content && <div>{content}</div>}
  </div>
);
